import { gql } from 'urql';

const AccountIds = gql`
  query AccountIds($product: [AccountProductEnum!]) {
    myAccounts {
      all {
        id
        product
      }
      id
      internalV2(products: $product) {
        id
        product
      }
    }
  }
`;

export default AccountIds;
